import * as Yup from 'yup';

const Validation = Yup.object({
    cat_id: Yup.string().required('Category is required'),
    name: Yup.string().required('Name is required'),
    // image: Yup.string().required('Image is required'),
    // status: Yup.string().required('Status is required'),
});
export default Validation;
